import cx from 'classnames';
import React from 'react';

import * as styles from './ButtonGroup.module.css';

const ButtonGroup = ({
	children,
	align,
	spacing,
	stretch,
	as: Component = 'div',
	className,
	hideOnMobile,
}: {
	children: React.ReactNode;
	align?: 'left' | 'center' | 'right';
	spacing?: 'md' | 'lg' | 'xl' | 'auto';
	stretch?: boolean;
	as?: React.ElementType;
	className?: string;
	hideOnMobile?: boolean;
}) => {
	return (
		<Component
			className={cx(
				styles.group,
				styles[`${align}Align`],
				styles[`${spacing}Spacing`],
				className,
				{ [styles.stretch]: stretch },
				{ [styles.hideOnMobile]: hideOnMobile }
			)}
		>
			{children}
		</Component>
	);
};

export default ButtonGroup;
